import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';


export const SectionContainer = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '40px 5%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
        padding: '30px 3%',
    },
}));

export const CircleContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '30px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: '40px',
    },
}));

export const Circle = styled('div')<{ imageUrl: string }>(({ imageUrl, theme }) => ({
    width: '280px',
    height: '280px',
    borderRadius: '50%',
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    opacity: 0.75,
    padding: '10px',
    boxShadow: '0px 0px 10px 2px rgba(255, 255, 255, 0.5)',
    transition: 'background-color 0.3s ease, transform 0.3s ease, opacity 0.3s ease',
    '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        transform: 'scale(1.05)',
        opacity: 1,
    },
    [theme.breakpoints.down('lg')]: {
        width: '240px',
        height: '240px',
    },
    [theme.breakpoints.down('md')]: {
        width: '220px',
        height: '220px',
    },
}));

export const TextContainer = styled('div')({
    color: 'white',
    textAlign: 'center',
    marginTop: '15px',
    padding: '0 10px',
});

export const CircleTypography = styled(Typography)(({ theme }) => ({
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: '10px',
    textAlign: 'center',
    color: theme.palette.primary.main,
    textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
    [theme.breakpoints.down('md')]: {
        fontSize: '1.8rem',
    },
}));

export const DescriptionTypography = styled(Typography)(({ theme }) => ({
    fontSize: '0.95rem',
    lineHeight: 1.6,
    margin: '10px 0',
    textAlign: 'center',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
        fontSize: '0.9rem',
    },
}));

export const CircleColumn = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '320px',
}))